import React, { useEffect, useState } from "react";
import LandingFullPreview from "./LandingFullPreview.jsx";

let installGuideOpen = false;
let beforeInstallUrl = null;

export function beginInstallGuide() {
  if (!installGuideOpen) {
    beforeInstallUrl =
      window.location.pathname + window.location.search + window.location.hash;
  }
  installGuideOpen = true;
  window.history.replaceState(window.history.state, "", "/app");
  window.dispatchEvent(new Event("fitmeup:entry-change"));
}

export function endInstallGuide() {
  if (!installGuideOpen) return;
  window.history.replaceState(window.history.state, "", beforeInstallUrl || "/");
  beforeInstallUrl = null;
  installGuideOpen = false;
  window.dispatchEvent(new Event("fitmeup:entry-change"));
}

function shouldOpenApp() {
  if (typeof window === "undefined") return false;
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;
  if (isStandalone) return true;
  const telegramInitData = window.Telegram?.WebApp?.initData;
  if (telegramInitData) return true;
  if (installGuideOpen) return false;
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
  if (pathname === "/app") return true;
  
  const params = new URLSearchParams(window.location.search);
  return params.get("telegram_login") === "error";
}

export default function AppEntry({ landing, children }) {
  const [openApp, setOpenApp] = useState(shouldOpenApp);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (!isStandalone) return;

    const storageKey = "fitmeup_first_open_tracked";

    if (localStorage.getItem(storageKey) === "1") return;

    const trackFirstOpen = () => {
      if (typeof window.gtag !== "function") return false;

      window.gtag("event", "app_first_open", {
        app_platform: /iPhone|iPad|iPod/i.test(navigator.userAgent)
          ? "ios"
          : "android",
        install_type: "home_screen"
      });

      localStorage.setItem(storageKey, "1");
      return true;
    };

    if (!trackFirstOpen()) {
      const timer = window.setInterval(() => {
        if (trackFirstOpen()) window.clearInterval(timer);
      }, 500);

      const timeout = window.setTimeout(() => {
        window.clearInterval(timer);
      }, 10000);

      return () => {
        window.clearInterval(timer);
        window.clearTimeout(timeout);
      };
    }
  }, []);

  useEffect(() => {
    const refresh = () => setOpenApp(shouldOpenApp());
    const displayMode = window.matchMedia("(display-mode: standalone)");
    const telegramScript = document.querySelector(
      'script[src*="telegram.org/js/telegram-web-app.js"]'
    );
    window.addEventListener("popstate", refresh);
    window.addEventListener("pageshow", refresh);
    window.addEventListener("fitmeup:entry-change", refresh);
    displayMode.addEventListener?.("change", refresh);
    telegramScript?.addEventListener("load", refresh);
    const timers = [0, 250, 1000].map((delay) => window.setTimeout(refresh, delay));
    return () => {
      window.removeEventListener("popstate", refresh);
      window.removeEventListener("pageshow", refresh);
      window.removeEventListener("fitmeup:entry-change", refresh);
      displayMode.removeEventListener?.("change", refresh);
      telegramScript?.removeEventListener("load", refresh);
      timers.forEach((id) => window.clearTimeout(id));
    };
  }, []);

  // The live site uses the same React landing as the former ?preview=hero route.
  return openApp ? children : <LandingFullPreview />;
}
